import { useCallback, useEffect } from 'react';

import { throttle } from 'lodash-es';

type Props = {
  callback: VoidFunction;
  wait?: number;
};

const useThrottleScrollCallback = ({ callback, wait = 100 }: Props) => {
  const onScroll = useCallback(() => {
    callback?.();
  }, [callback]);

  useEffect(() => {
    const throttleOnScroll = throttle(onScroll, wait);

    window.addEventListener('scroll', throttleOnScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', throttleOnScroll);
    };
  }, [onScroll, wait]);
};

export default useThrottleScrollCallback;
